export const projectsData = [
  {
    id: 9,
    title: 'Campestre',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750874594/IMG-20250620-WA0511_oktjpk.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874594/IMG-20250620-WA0511_oktjpk.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874592/IMG-20250620-WA0816_jcdnzb.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874590/IMG-20250620-WA0510_sxinrk.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874588/IMG-20250620-WA0509_elumet.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874586/IMG-20250620-WA0413_nvlwfi.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874585/IMG-20250620-WA0412_xf8u9l.jpg'
    ]
  },
  {
    id: 12,
    title: 'Kitnet Comercial Sorocaba',
    subtitle: 'Comercial',
    category: 'comercial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750873517/IMG-20250620-WA0602_hsjdcv.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873517/IMG-20250620-WA0602_hsjdcv.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873518/IMG-20250620-WA0603_xw8pmh.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873520/IMG-20250620-WA0595_rdezoa.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873523/IMG-20250620-WA0594_t51p8k.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873525/IMG-20250620-WA0592_wyrwkr.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873527/IMG-20250620-WA0593_dcwfql.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873527/IMG-20250620-WA0589_x4ecvt.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873528/IMG-20250620-WA0587_xdwun6.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873532/IMG-20250620-WA0585_go3hwv.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873537/IMG-20250620-WA0581_uobelc.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750873540/IMG-20250620-WA0879_s3e7kn.jpg'
    ]
  },
  {
    id: 13,
    title: 'Gourmet I',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750878807/Captura_de_tela_2025-06-25_161221_hbqwcy.png',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/video/upload/v1750874598/V%C3%ADdeo_do_WhatsApp_de_2025-06-25_%C3%A0_s_13.24.52_17e73c7e_rpwh8c.mp4'
    ]
  },
  {
    id: 1,
    title: 'EAD Skill',
    subtitle: 'Comercial',
    category: 'comercial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750872146/IMG-20250620-WA0218_saacmt.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750872146/IMG-20250620-WA0218_saacmt.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750872148/IMG-20250620-WA0235_gcsj3f.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750872146/IMG-20250620-WA0224_a91lwx.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750872146/IMG-20250620-WA0226_d7ym7s.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750872146/IMG-20250620-WA0229_psti3r.jpg'
    ]
  },
  {
    id: 2,
    title: 'DEX',
    subtitle: 'Comercial',
    category: 'comercial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691261/IMG-20250620-WA0540_eozxvm.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691261/IMG-20250620-WA0540_eozxvm.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691260/IMG-20250620-WA0538_ddkzt6.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691260/IMG-20250620-WA0539_aavpok.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691260/IMG-20250620-WA0280_r0fj4r.jpg'
    ]
  },
  {
    id: 3,
    title: 'São Pedro',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691418/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.43.52_abb68953_qzb4je.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691419/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.43.53_e4da7b38_zu5w6y.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691418/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.43.52_882c7030_nrhpmi.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691418/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.43.52_abb68953_qzb4je.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691418/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.43.53_0d109617_zsnb3l.jpg'
    ]
  },
  {
    id: 4,
    title: 'Alambari',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691445/IMG-20250620-WA0648_e9hxnk.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691445/IMG-20250620-WA0648_e9hxnk.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691445/IMG-20250620-WA0647_afsbjv.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691445/IMG-20250620-WA0645_fvmirk.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691445/IMG-20250620-WA0644_b5iy9f.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691444/IMG-20250620-WA0643_bjieul.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691444/IMG-20250620-WA0642_iyyfi2.jpg'
    ]
  },
  {
    id: 5,
    title: 'F&E',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750692049/IMG-20250620-WA0283_m3bqsi.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750692049/IMG-20250620-WA0283_m3bqsi.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750692067/IMG-20250620-WA0285_iwjgba.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750692026/IMG-20250620-WA0284_jvlfho.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750692007/IMG-20250620-WA0282_aycuw3.jpg'
    ]
  },
  {
    id: 6,
    title: 'Terras de Artemis',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691439/IMG-20250620-WA0736_wnairp.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691439/IMG-20250620-WA0736_wnairp.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691438/IMG-20250620-WA0200_cblb8h.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691440/IMG-20250620-WA0740_w0o8xu.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691439/IMG-20250620-WA0737_anplqg.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691441/IMG-20250620-WA0746_mkehhn.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691443/IMG-20250620-WA0751_v4nc4s.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691443/IMG-20250620-WA0752_mywck0.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691443/IMG-20250620-WA0875_lazoug.jpg'
    ]
  },
  {
    id: 7,
    title: 'Pro Formance',
    subtitle: 'Comercial',
    category: 'comercial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.58.56_91d9447b_jntzy1.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.58.56_91d9447b_jntzy1.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.59.53_240c433e_raijx7.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.59.52_5db9ef21_k6aqxp.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.59.52_20881d22_lznxqo.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691259/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.58.56_9f3ca249_js3nld.jpg'
    ]
  },
  {
    id: 8,
    title: 'Beach Tennis',
    subtitle: 'Projeto de Área Externa',
    category: 'outros',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750874240/IMG-20250620-WA0261_kg6uoz.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874240/IMG-20250620-WA0261_kg6uoz.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874241/IMG-20250620-WA0262_vu32sd.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750874239/IMG-20250620-WA0264_farzgz.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691410/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_10.58.02_beee4180_wmyfai.jpg'
    ]
  },
  {
    id: 10,
    title: 'Dama II',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750875833/IMG-20250620-WA0256_pltts7.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875833/IMG-20250620-WA0256_pltts7.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875872/IMG-20250620-WA0260_vco51a.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875869/IMG-20250620-WA0257_knxmr3.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875866/IMG-20250620-WA0534_ambxdq.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875830/IMG-20250620-WA0258_ixcnze.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750875828/IMG-20250620-WA0259_s9aq0a.jpg'
    ]
  },
  {
    id: 11,
    title: 'Quinta do Engenho',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691450/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.49.56_b60197ff_q8mdcf.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691450/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.49.56_b60197ff_q8mdcf.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691450/IMG-20250620-WA0808_h3ryju.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691450/IMG-20250620-WA0809_kimxep.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691451/IMG-20250620-WA0812_xdyokm.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691451/IMG-20250620-WA0813_qm6jm0.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691451/IMG-20250620-WA0814_z8ak0c.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691451/IMG-20250620-WA0811_rhgj25.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691450/IMG-20250620-WA0810_d54f11.jpg'
    ]
  },
  {
    id: 14,
    title: 'Represa',
    subtitle: 'Projeto de Construção e Design',
    category: 'outros',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691403/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.48.40_ac17ff8d_ynxfju.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691403/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_13.48.40_ac17ff8d_ynxfju.jpg'
    ]
  },
  {
    id: 15,
    title: 'Projeto Ypes',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750880082/IMG-20250620-WA0360_kjzwly.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880082/IMG-20250620-WA0360_kjzwly.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880076/IMG-20250620-WA0359_cwsxm0.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880095/IMG-20250620-WA0364_nzoibs.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880089/IMG-20250620-WA0361_ehtdy1.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880070/IMG-20250620-WA0362_llhigm.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880063/IMG-20250620-WA0367_woslmv.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880058/IMG-20250620-WA0365_reml7k.jpg'
    ]
  },
  {
    id: 16,
    title: 'V&V',
    subtitle: 'Projeto de Design',
    category: 'outros',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691860/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_11.09.55_ab08fcc3_jjllfo.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691860/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_11.09.55_ab08fcc3_jjllfo.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691868/IMG-20250620-WA0331_ymxgbw.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691868/IMG-20250620-WA0330_r2qfpc.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691867/IMG-20250620-WA0329_z5w4u3.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691866/IMG-20250620-WA0328_j0he3s.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691866/IMG-20250620-WA0327_gdosux.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691865/IMG-20250620-WA0326_bosnqh.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691862/IMG-20250620-WA0322_tq1dkx.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691861/IMG-20250620-WA0321_hx0vnx.jpg'
    ]
  },
  {
    id: 18,
    title: 'Nova Piracicaba',
    subtitle: 'Projeto de Reforma',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750881052/IMG-20250620-WA0446_ebo48b.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881052/IMG-20250620-WA0446_ebo48b.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881645/IMG-20250620-WA0419_bm9igh.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881631/IMG-20250620-WA0417_ybhhlq.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881611/IMG-20250620-WA0424_h22z4o.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880695/IMG-20250620-WA0451_zgi9by.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880701/IMG-20250620-WA0452_wuyjzi.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880707/IMG-20250620-WA0455_gcsgsb.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880714/IMG-20250620-WA0450_tiwv8z.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750880720/IMG-20250620-WA0448_b6xuxs.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881058/IMG-20250620-WA0447_daposw.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881557/IMG-20250620-WA0441_a32ynh.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881564/IMG-20250620-WA0437_ujerib.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881671/IMG-20250620-WA0414_vsomzs.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881658/IMG-20250620-WA0415_sgpqhg.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750881665/IMG-20250620-WA0416_rjvtlb.jpg'
    ]
  },
  {
    id: 34,
    title: 'LF',
    subtitle: 'Projeto de Construção Residencial',
    category: 'residencial',
    mainImage: 'https://res.cloudinary.com/dthbszpto/image/upload/v1750691459/IMG-20250620-WA0342_vpwaki.jpg',
    gallery: [
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691459/IMG-20250620-WA0342_vpwaki.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691459/IMG-20250620-WA0344_aammzx.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691458/IMG-20250620-WA0341_t4hhjn.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691458/IMG-20250620-WA0338_ouhztr.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691458/IMG-20250620-WA0337_ww9zc4.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691458/IMG-20250620-WA0339_krttx5.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691457/IMG-20250620-WA0332_x5hfc2.jpg',
      'https://res.cloudinary.com/dthbszpto/image/upload/v1750691457/Imagem_do_WhatsApp_de_2025-06-20_%C3%A0_s_11.11.20_9cc302d0_arvedw.jpg'
    ]
  }
];